/**
 * Bumped on every breaking wire change. One version is spoken at a time: a client left open across
 * a release cannot read the server any more and asks its player to reload (ADR 0012, review 0027 C1).
 */
export const PROTOCOL_VERSION = 2;
/**
 * The table closed the socket because it will not have this player (its spectators are full):
 * the client must not try the same table again (review 0027 D7). In the range WebSocket leaves
 * to applications.
 */
export const REFUSED_CLOSE_CODE = 4009;
//# sourceMappingURL=version.js.map